import {useEffect} from 'react'
import {Navigate, Routes, useParams} from 'react-router-dom'

export const Logout = () => {
  const getUrlParams = useParams()

  useEffect(() => {
    window.localStorage.clear()
    document.location.reload()
    localStorage.removeItem('role')
  }, [])

  return (
    <Routes>
      <Navigate to={`/${getUrlParams.adminUser}/logout`} />
    </Routes>
  )
}
